import { isWeb } from '../../../constants';
/**
 * Container for the Groups option modals. On web, inset the options so their
 * hover highlight sits inside the modal.
 */
export const groupModalContainerStyle = {
    paddingHorizontal: 0,
    overflow: 'hidden',
    ...(isWeb && { paddingHorizontal: 8, paddingBottom: 8 }),
};
